import FastingHeader from './FastingHeader';

export default FastingHeader;
